import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { isNoPermissionVisit, linkToWeapp } from "@/config/index";
Vue.use(VueRouter);

import root from "./modules/root";
import home from "./modules/home";
import share from "./modules/share";
import auth from "./modules/auth";
import dashboard from "./modules/dashboard";
import zcfg from "./modules/zcfg";
import ansReport from "./modules/ansReport";
import tools from "./modules/tools";

export const routes = [
  ...root,
  ...home,
  ...share,
  ...auth,
  ...dashboard,
  ...zcfg,
  ...ansReport,
  ...tools,
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.VUE_APP_PATH,
  routes,
});

// 注册 beforeEach 钩子函数
router.beforeEach((to, from, next) => {
  try {
    const id = to.path.split("/chat/")[1];
    store.dispatch("chat/setCurrentChat", { id: id });
  } catch (error) {}

  if (to.meta.title) {
    document.title = `${to.meta.title}-税收数字化实训平台`;
  } else {
    document.title = "税收数字化实训平台";
  }
  if (linkToWeapp(to.fullPath)) {
    next("/weapp");
  } else if (isNoPermissionVisit(to.fullPath)) {
    // 如果是无权限访问的页面，直接放行
    next();
  } else if (
    localStorage.getItem("Authorization") ||
    localStorage.getItem("userInfo")
  ) {
    // 验证用户是否已登录
    next();
  } else {
    // 否则重定向到登录页面
    next("/landing");
  }
});
export default router;
